import { TRANSITION_TIME, TRANSITION_TIME_LONG } from 'lib/constants/transitionTimes';
import baseStyled, { createGlobalStyle, css, RuleSet } from 'styled-components';
import { COLOR } from './styled-components-colors';
import { SHADOW } from './styled-components-shadows';
import { BORDER_RADIUS } from './styled-components-border-radius';
const COLUMN_WIDTH = 1562;
const COLUMN_PADDING = 10;

const COLUMN_PADDING_NEW = 20;

export const maxSiteWidth = css`
    max-width: ${COLUMN_WIDTH}px;
    margin: 0 auto;
    width: 100%;
`;

export const maxSiteWidthWithPadding = css`
    max-width: ${COLUMN_WIDTH + COLUMN_PADDING + COLUMN_PADDING}px;
    margin: 0 auto;
    width: 100%;
    padding: 0 ${COLUMN_PADDING}px;
`;

export const NEW_MAX_SITE_WIDTH_WITH_PADDING = COLUMN_WIDTH + COLUMN_PADDING_NEW + COLUMN_PADDING_NEW;

export const maxSiteWidthWithPaddingNew = css`
    max-width: ${NEW_MAX_SITE_WIDTH_WITH_PADDING}px;
    margin: 0 auto;
    width: 100%;
    padding: 0 ${COLUMN_PADDING_NEW}px;
`;

const createCssColors = (): RuleSet => {
    const styles = Object.entries(COLOR)
        .map(([key, value]) => {
            return `--${key}: ${value};`;
        })
        .join(' ');

    return css`
        ${styles}
    `;
};

const createCssShadows = (): RuleSet => {
    const styles = Object.entries(SHADOW)
        .map(([key, value]) => {
            return `--${key}: ${value};`;
        })
        .join(' ');
    return css`
        ${styles}
    `;
};

const createCssBorderRadius = (): RuleSet => {
    const styles = Object.entries(BORDER_RADIUS)
        .map(([key, value]) => {
            return `--${key}: ${value};`;
        })
        .join(' ');
    return css`
        ${styles}
    `;
};

export const APP_CONTAINER_CLASSNAME = 'App';
export const APP_CONTAINER_MIN_SIZE_PX = 1144;

export const GlobalStyle = createGlobalStyle`
    :root {
        ${createCssColors()}
        ${createCssShadows()}
        ${createCssBorderRadius()}
        --animationTime: ${TRANSITION_TIME}ms;
        --animationTimeLong: ${TRANSITION_TIME_LONG}ms;
        --toastify-color-info: var(--blueRibbon);
        --toastify-color-success: var(--apple);
        --toastify-color-warning: var(--buddhaGold);
        --toastify-color-error: var(--scarlet);
    }
    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth
    }

    body {
        margin:0;
        font-size: 16px;
        font-family: 'Noto Sans', sans-serif;
        color: var(--tundora);
        font-weight:400;
        line-height:1.5;
        text-align:left;
        background-color: var(--white);

        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
            position: absolute;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--manatee);
            border-radius: 2px;
            width: 4px;
            height: 4px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: var(--stormGray);
        }
    }

    a {
        color: var(--blueRibbon);
        text-decoration: none;
        background-color: transparent;
        -webkit-text-decoration-skip: objects;
    }

    a:hover {
        color: var(--scienceBlue);
        text-decoration: underline;
    }

    a:not([href]):not([tabindex]) {
        color: inherit;
        text-decoration: none;
    }

    a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
        color: inherit;
        text-decoration: none;
    }

    a:not([href]):not([tabindex]):focus {
    outline: 0;
    }

    button {
        cursor: pointer;
        font-family: inherit;
    }

    input {
        font-family: inherit;
    }

    pre {
        font-family: inherit;
    }

    table {
        border-collapse: collapse;
    }

    th {
        text-align: inherit;
    }

    label {
        display: inline-block;
        margin-bottom: 0.5rem;
    }

    .row {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
    }

    .col-sm-12, .col-md-6, .col-lg-4, .col-lg-8 {
        position: relative;
        width: 100%;
        min-height: 1px;
        padding-right: 15px;
        padding-left: 15px;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

        .col-md-6 {
            -ms-flex: 0 0 50%;
            flex: 0 0 50%;
            max-width: 50%;
        }


        .col-lg-4 {
            -ms-flex: 0 0 33.333333%;
            flex: 0 0 33.333333%;
            max-width: 33.333333%;
        }

        .col-lg-8 {
            -ms-flex: 0 0 66.666667%;
            flex: 0 0 66.666667%;
            max-width: 66.666667%;
        }


    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .rs-picker-toggle-value > div > div > div {
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-start;
        align-items: center;
    }

    .rs-picker-menu {
        margin-top: 8px;
    }

    .rs-picker-popup {
        padding: 16px 0;
    }

    .rs-picker-select-menu-items{
        padding: 0 8px;
        margin-bottom: 0;
    }

    .rs-picker-menu.rs-picker-check-menu, .rs-picker-menu.rs-picker-select-menu{
        padding-top: 0;
    }

    .rs-picker-select-menu.rs-picker-select-menu-items {
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
            position: absolute;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--manatee);
            border-radius: 2px;
            width: 4px;
            height: 4px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: var(--stormGray);
        }
    }



    .rs-check-item{
        &:hover{
            background-color: var(--transparent)
        }
        .rs-checkbox-checker>label {
            font-size: 14px;
            color: var(--ebonyClay);
            line-height: 24px;
            font-weight: 500;
        }
    }

    .rs-picker-check-menu-items .rs-check-item.rs-checkbox-checked .rs-checkbox-checker>label{
        font-weight: 500;
    }



    .rs-check-item.rs-check-item-focus,
    .rs-check-item:focus,
    .rs-check-item:not(.rs-checkbox-disabled):hover{
            background-color: var(--transparent)
    }

    .rs-checkbox-checker{
        &>label{
            &:hover{
                &:last-child{
                    transition: color var(--animationTime);
                    color: var(--blueRibbon);
                }
            }
        }
    }

    .rs-checkbox-wrapper{
        top: 12px;
        &:before{
            border: 1px solid var(--manatee);
        }
    }

    .rs-checkbox-checked .rs-checkbox-wrapper .rs-checkbox-inner:before,
    .rs-checkbox-indeterminate .rs-checkbox-wrapper .rs-checkbox-inner:before{
        background-color: var(--blueRibbon);
        border-color: var(--blueRibbon);
    }

    .rs-picker-select-menu-item {
        font-size: 14px;
        color: var(--ebonyClay);
        min-height: 24px;
        font-weight: 500;
        transition: all var(--animationTime);
        padding: 8px;

        &:hover {
            background-color: var(--transparent)
        }

        &:hover .rs-select-picker-menu-item__custom-label {
            color: var(--blueRibbon);
            svg:first-of-type{
                fill: var(--blueRibbon);
            }
        }

        &:hover .rs-select-picker-menu-item__custom-label-description-right {
            color: var(--blueRibbon);
        }
    }

    .rs-picker-select-menu-item:has(.menu-item__hidden) {
        display: none;
    }

    .rs-picker-menu-group {
        pointer-events: none;
        border-top: none!important;

        .rs-picker-menu-group-title {
            font-size: 13px;
            line-height:16px;
            color: var(--manatee);
        }

        svg {
            display: none!important;
        }
    }

    .rs-picker-select-menu-item.rs-picker-select-menu-item-active {
        background-color: var(--white);
        color: var(--blueRibbon);
        font-weight: 500;

        & .rs-select-picker-menu-item__custom-label-description-right {
            font-weight: 700;
            color: var(--ebonyClay);
            font-size: 13px;
        }

        &:hover {
            color: var(--blueRibbon);
        }

        .rs-select-picker-menu-item__custom-label{
            color: var(--blueRibbon);
            svg{
                fill: var(--blueRibbon);
            }
        }
    }

    .rs-picker-select-menu-item.rs-picker-select-menu-item-disabled {
        color: var(--ebonyClay);
        opacity: 0.4;
    }

    .rs-picker-select-menu-item:hover.rs-picker-select-menu-item-disabled, .rs-picker-select-menu-item.pseudo-hover.rs-picker-select-menu-item-disabled, .pseudo-hover .rs-picker-select-menu-item.rs-picker-select-menu-item-disabled {
        color: var(--ebonyClay);
        background: none;
    }

    .rs-picker-select-menu-item.rs-picker-select-menu-item-focus {
        background-color: var(--transparent);
    }

    .rs-picker-menu .rs-picker-search-bar .rs-picker-search-bar-input {
        min-width: unset;
        width: 100%;
    }

    .rs-modal-wrapper {
        display: flex;
        align-items: center;
        overflow: hidden;
    }

    body.rs-modal-open.content-library-view-modal {
        overflow: visible;
        padding-right: 0 !important;
    }

    .rs-picker-tag .rs-picker-toggle.rs-btn~.rs-picker-tag-wrapper {
        text-align: left;
    }

    .rs-collapsible-panel {
        padding: 16px;
    }

    .rs-collapsible-panel.rs-collapsible-panel-bordered {
        border: 1px solid var(--border);
        border-radius: 8px;
    }

    .rs-collapsible-panel .rs-panel-btn {
        height: 40px;
    }

    .rs-collapsible-panel .rs-panel-btn:hover, .rs-collapsible-panel .rs-panel-btn:active, .rs-collapsible-panel .rs-panel-btn:focus {
        background: transparent;
    }

    .Toastify__toast-container {
        width: 358px !important;
    }

    .Toastify__toast {
        padding: 12px !important;
        width: 350px !important;
        border-radius: 8px !important;
        border: 1px solid var(--mercury);
        box-shadow: 0 0 24px 0 rgba(0,0,0,0.08) !important;
    }

    .Toastify__progress-bar {
        height: 2px !important;
    }

    img {
        max-width: 100%;
        height: auto;
    }

    h1,h2,h3,h4,h5,h6 {
        margin: 0;
        padding: 0;
    }

    .user-panel{
        &__wrapper {
            ${maxSiteWidth};
        }

        &__column {
            padding-top: 25px;
            z-index: 10;
            min-height: 100vh;

            &.right {
                padding-top: 222px;
                background-color: var(--athensGray);
                z-index: 0;
            }
            a {
                margin-left: 20px;
                svg {
                width: 24px;
                height: 16px;
                fill: var(--iron);
                }
            }
        }

        .edit-mode__overlay {
            &.active {
                position: fixed;
                background: var(--iron08);
                width: 100%;
                height: 100%;
                top: 0px;
                left: 40%;
                z-index: 10;
            }
        }
    }

    .wave-img {
        position: absolute;
        top: -64px;
        left: 0;
        width: 100%;
        z-index: 5;
        &--blue{
            svg {
                fill: var(--luckyPoint);
                width: 100%;
                height: 270px;
            }
        }
    }

    .form-control:not([type="radio"]):not([type="checkbox"]) {
        border: 1px solid var(--ghost04);
        font-size: 13px;
        height: auto;
        padding: 10px 20px;
        border-radius: 8px;
        box-shadow: 0px 5px 5px -3px inset var(--ghost03);
        color: var(--toreaBay);
    }

    .text--right {
        text-align: right;
    }

    .table {
        width: 100%;
        table-layout: fixed;
        td, th {
            border: 0;
            padding: 5px;
            vertical-align: middle;
        }
        thead th,
        th {
            font-weight: normal;
            font-size: 9px;
            color: var(--manatee);
            border-bottom: 1px solid var(--manatee02);
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        td {
            padding-top: 10px;
            padding-bottom: 10px;
            font-size: 13px;
            .avatar {
                padding: 5px;
            }
        }
        tr {
            transition: transform 0.2s;
            td {
                border-bottom: 1px solid var(--manatee02);
            }
            &:last-child {
                td {
                    border-bottom: 0;
                }
            }
        }
        tbody tr {
            &:hover {
                transition: all 0.2s;
                box-shadow: 0px 0px 5px rgba(0,0,0,0.1);
            }
        }
        &__row-link {
            tr {
                cursor: pointer;
            }
        }
    }

    .status-dropdown {
        .rs-picker-search-bar {
            &::before {
                content: 'Status';
                display: flex;
                color: var(--manatee);
                font-size: 14px;
                line-height: 24px;
                font-weight: 500;
                margin-bottom: 8px;
            }

            .rs-picker-search-bar-search-icon.rs-icon {
                top: unset;
                bottom: 20px;
            }
        }
    }

    .user-picker {
        .rs-picker-search-bar {
            &::before {
                content: 'Assigned to';
                display: flex;
                color: var(--manatee);
                font-size: 14px;
                line-height: 24px;
                font-weight: 500;
                margin-bottom: 8px;
            }

            .rs-picker-search-bar-search-icon.rs-icon {
                top: unset;
                bottom: 20px;
            }
        }
    }

    .fade-appear {
        opacity: 0;
    }

    .fade-appear-active {
        opacity: 1;
        transition: opacity 300ms ease-in-out!important;
    }

    .fade-appear-done {
        opacity: 1;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-enter-active {
        opacity: 1;
        transition: opacity 300ms ease-in-out!important;
    }

    .fade-enter-done {
        opacity: 1;
    }

    .fade-exit {
        opacity: 1;
    }

    .fade-exit-active {
        opacity: 0;
        transition: opacity 300ms ease-in-out!important;
    }

    .fade-exit-done {
        opacity: 0;
    }

    @keyframes scaleIn {
        from {
            transform: scale(0.8);
            opacity: 0;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    .${APP_CONTAINER_CLASSNAME} {
        min-width: ${APP_CONTAINER_MIN_SIZE_PX}px;

        &.${APP_CONTAINER_CLASSNAME}--no-min-width {
            min-width: unset;
        }
    }

    .tiptap {
        p.is-editor-empty:first-child::before {
            content: attr(data-placeholder);
            float: left;
            height: 0;
            pointer-events: none;
            color: var(--manatee);
            font-size: 14px;
            line-height: 16px;
        }
    }

    blockquote {
        border-left: 3px solid var(--mercury);
        margin: 1.5rem 0;
        padding-left: 1rem;
    }
`;

export type Overflow = 'hidden' | 'visible' | 'clip' | 'scroll' | 'auto';
export const resolveOverflow = (overflow: Overflow | [Overflow, Overflow]): string => {
    if (Array.isArray(overflow)) {
        return `${overflow[0]} ${overflow[1]}`;
    }
    return overflow;
};

export type ThemeColor = keyof typeof COLOR;
export type ColorValue = (typeof COLOR)[ThemeColor];
export type ThemeShadow = keyof typeof SHADOW;
export type ShadowValue = (typeof SHADOW)[ThemeShadow];
export type ThemeBorderRadius = keyof typeof BORDER_RADIUS;
export type BorderRadiusValue = (typeof BORDER_RADIUS)[ThemeBorderRadius];
export const styled = baseStyled;
